export default {
    onShareAppMessage () {
        return this.getShareInfo({
            title: `新房、二手房税费计算，点击查询~`,
            path: `/packageA/taxes_calculate/main`,
            imageUrl: 'https://cdn.vip-wifi.com/fangchan/img/packageA/taxes_calculate/forward.png'
        })
    }
}